import { FaRankingStar, FaBoxArchive, FaThumbsUp, FaChartLine, FaMagnet } from 'react-icons/fa6';
import styles from './TrustNumbers.module.css';

const highlights = [
  { icon: FaRankingStar, headline: '+7 anos', subtext: 'de experiência em criação de sites.' },
  { icon: FaBoxArchive, headline: '+300 projetos', subtext: 'de sites entregues.' },
  { icon: FaThumbsUp, headline: '99% de satisfação', subtext: 'pós entrega.' },
  { icon: FaChartLine, headline: '+70% de chances', subtext: 'de você ser encontrado.' },
  { icon: FaMagnet, headline: '+75% aumento', subtext: 'de leads gerados.' },
];

export default function TrustNumbers() {
  return (
    <section className={styles.wrapper} aria-labelledby="trust-heading">
      <div className={styles.heroBand}>
        <div className={styles.heroInner}>
          <header className={styles.heroHeader}>
            <h2 id="trust-heading">Números que comprovam a qualidade do meu trabalho</h2>
            <p>Meu objetivo é transformar sua presença digital e gerar mais oportunidades para seu negócio.</p>
          </header>

          <div className={styles.highlights}>
            {highlights.map(({ icon: Icon, headline, subtext }) => (
              <article key={headline} className={styles.highlightCard}>
                <span className={styles.highlightIcon} aria-hidden="true">
                  <Icon />
                </span>
                <h3>{headline}</h3>
                <p>{subtext}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
